import { TinyDropdownMenu, Toolbar } from '@octopus-do/octopus-storybook'
import {
  ChartSimple,
  Clipboard,
  Clone,
  Copy,
  EllipsisVertical,
  Sitemap,
} from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

// Key the menu reports to Toolbar.Root; the picked item follows it.
export const MORE_MENU_ID = 'more'

interface ContentProps {
  copyTreeDisabled: boolean
  duplicateDisabled: boolean
  pasteDisabled: boolean
  seoDisabled: boolean
}

const Content: React.FC<ContentProps> = ({
  copyTreeDisabled,
  duplicateDisabled,
  pasteDisabled,
  seoDisabled,
}) => (
  <>
    <TinyDropdownMenu.Group>
      <TinyDropdownMenu.Button
        disabled={seoDisabled}
        icon={ChartSimple}
        id="seo"
        label="SEO Tags"
      />
    </TinyDropdownMenu.Group>
    <TinyDropdownMenu.Divider />
    <TinyDropdownMenu.Group>
      <TinyDropdownMenu.Button icon={Copy} id="copy" label="Copy" />
      <TinyDropdownMenu.Button
        disabled={duplicateDisabled}
        icon={Clone}
        id="duplicate"
        label="Duplicate"
      />
      <TinyDropdownMenu.Button
        disabled={pasteDisabled}
        icon={Clipboard}
        id="paste"
        label="Paste"
      />
      <TinyDropdownMenu.Button
        disabled={copyTreeDisabled}
        icon={Sitemap}
        id="copy_tree"
        label="Copy tree"
      />
    </TinyDropdownMenu.Group>
  </>
)

// The menu closes on Paste, so the button carries the loader while the
// clipboard is read and applied.
const Trigger = forwardRef<HTMLButtonElement, { loading: boolean }>(
  ({ loading }, ref) => {
    const { active, toggle } = TinyDropdownMenu.useTrigger()

    return (
      <Toolbar.DropdownButton
        active={active}
        icon={EllipsisVertical}
        loading={loading}
        onClick={toggle}
        ref={ref}
        tooltip="More"
      />
    )
  }
)

interface Props {
  copyTreeDisabled: boolean
  duplicateDisabled: boolean
  pasteDisabled: boolean
  pasting: boolean
  seoDisabled: boolean
}

export const MoreMenu: React.FC<Props> = ({
  copyTreeDisabled,
  duplicateDisabled,
  pasteDisabled,
  pasting,
  seoDisabled,
}) => {
  const { onClick } = Toolbar.useToolbarClick(MORE_MENU_ID)

  return (
    <TinyDropdownMenu.Root
      content={Content}
      copyTreeDisabled={copyTreeDisabled}
      duplicateDisabled={duplicateDisabled}
      onClick={onClick}
      pasteDisabled={pasteDisabled}
      seoDisabled={seoDisabled}
    >
      <Trigger loading={pasting} />
    </TinyDropdownMenu.Root>
  )
}
